var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.937V17.1285C0 15.869 0.727278 14.7985 1.81819 14.2947L6.12122 12.5945V23.1108C6.12122 24.1184 5.33334 24.937 4.30304 24.937H0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51516 24.937V10.8312C7.51516 9.57179 8.30304 8.50126 9.33334 7.99748L13.6364 6.23426V23.0479C13.6364 24.1184 12.8485 24.937 11.8182 24.937H7.51516Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.59698C15 3.33753 15.7273 2.267 16.8182 1.76322L21.1212 0V23.1108C21.1212 24.1814 20.3333 25 19.303 25H15V4.59698Z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyMiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMjQuOTM3VjE3LjEyODVDMCAxNS44NjkgMC43MjcyNzggMTQuNzk4NSAxLjgxODE5IDE0LjI5NDdMNi4xMjEyMiAxMi41OTQ1VjIzLjExMDhDNi4xMjEyMiAyNC4xMTg0IDUuMzMzMzQgMjQuOTM3IDQuMzAzMDQgMjQuOTM3SDBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTcuNTE1MTYgMjQuOTM3VjEwLjgzMTJDNy41MTUxNiA5LjU3MTc5IDguMzAzMDQgOC41MDEyNiA5LjMzMzM0IDcuOTk3NDhMMTMuNjM2NCA2LjIzNDI2VjIzLjA0NzlDMTMuNjM2NCAyNC4xMTg0IDEyLjg0ODUgMjQuOTM3IDExLjgxODIgMjQuOTM3SDcuNTE1MTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTE1IDQuNTk2OThDMTUgMy4zMzc1MyAxNS43MjczIDIuMjY3IDE2LjgxODIgMS43NjMyMkwyMS4xMjEyIDBWMjMuMTEwOEMyMS4xMjEyIDI0LjE4MTQgMjAuMzMzMyAyNSAxOS4zMDMgMjVIMTVWNC41OTY5OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgLogoSmall as ReactComponent };